<template>
  <div>
    <v-row class="loader fill-height py-6" align="center" justify="center" v-if="isTimePeriodFormLoading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-row>
    <div class="timeperiods" :class="{ 'pa-5': xsOrsm, 'pa-6': breakpointMd, 'pa-4': xlOrlg }" v-else>
      <div class="timeperiods-body__header d-sm-flex align-center" :class="{ 'text-center': breakpointXs }">
        <div class="timeperiods-body__header--title fs-25 fw-600">
          Time Periods
        </div>
        <v-spacer v-if="!breakpointXs"></v-spacer>
        <div class="timeperiods-body__header__search" :class="{ 'mt-3': breakpointXs, 'mr-4': !breakpointXs }">
          <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
        </div>
        <div class="timeperiods-body__header--button" :class="{ 'mt-3': breakpointXs }">
          <v-btn width="180" color="primary" large class="white--text" @click="addNewTimePeriod">
            <v-icon left>fas fa-plus</v-icon>
            <span class="font-weight-bold fs-15">Add New</span>
          </v-btn>
        </div>
      </div>
      <div class="timeperiods-body__table mt-2">
        <v-data-table
          :items-per-page="5"
          :headers="tableHeaders"
          :loading="isTableLoading"
          :items="timePeriodsArray"
          :search="search"
        >
          <template v-slot:item.deleteAction="{ item }">
            <v-btn
              color="lightPrimary"
              :loading="item.isDeletingTimePeriodLoading"
              class=" error font-weight-bold"
              :disabled="isLastTimePeriod"
              dense
              @click="deleteActionHandler(item)"
              >Delete</v-btn
            >
          </template>
        </v-data-table>
        <AddTimePeriod
          :timePeriodObject="timePeriodObject"
          :loader="isTableLoading"
          @add-timePeriod="addTimePeriod"
          @update-timePeriod="updateTimePeriod"
          @close-timePeriod-dialog="closeDialog"
          v-if="showTimePeriodModal"
        />
        <ConfirmDeleteDialog
          v-if="showDeleteConfirmationDialog"
          :loader="isDeletingTimePeriod"
          @clicked-yes="deleteTimePeriod(storeTimePeriod)"
          @clicked-no="showDeleteConfirmationDialog = false"
        />
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { SNACKBAR } from "@/store/actionTypes";
import * as AT from "@/modules/DashboardModule/store/actionTypes";
import AddTimePeriod from "@/modules/DashboardModule/components/settings/AddTimePeriod";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
import ConfirmDeleteDialog from "@/modules/DashboardModule/components/ConfirmDeleteDialog";

export default {
  name: "TimePeriod",
    components: {
     AddTimePeriod,
     ConfirmDeleteDialog
  },
  data() {
	  return {
        search: "",
        isTableLoading:false,
        isLastTimePeriod:false,
        isDeletingTimePeriod: false,
        showDeleteConfirmationDialog: false,
        showTimePeriodModal: false,
        isTimePeriodFormLoading: false,
        timePeriodsArray:[],
        timePeriodObject:{
            id:'',
            description:'',
            startDate:'',
            endDate:'',
            action:'add'
        },
        storeTimePeriod: null
	  }
  },
  mixins:[commonMethodsMixin],
  mounted() {
      this.getTimePeriods();
      },
  methods: {
     addNewTimePeriod(){
        this.timePeriodObject = this.getEmptyTimePeriod();
        this.showTimePeriodModal = true;
        return;
     },
     deleteActionHandler(timePeriodData){
         const globalTimePeriodId = this.$store.getters.globalTimePeriod;
      if (globalTimePeriodId === timePeriodData.id) {
        this.$store.dispatch(SNACKBAR, {
          color: "error",
          text: `Please Change Time Period First`
      });
      return;
      }else{
      this.showDeleteConfirmationDialog = true;
      this.storeTimePeriod = timePeriodData;
      }
     },
     mapSrNoToTimePeriod() {
      this.timePeriodsArray.map((timePeriod, index) => {
        timePeriod.srNo = index + 1;
      });
    },
     getEmptyTimePeriod() {
      return {
        id:'',
        description:'',
        startDate:'',
        endDate:'',
        action:'add'
      };
    },
    addTimePeriod() {
    const formData = {
        name: this.timePeriodObject.description,
        end_date: this.timePeriodObject.endDate,
        start_date: this.timePeriodObject.startDate
      };
      this.isTableLoading = true;
      this.$store
        .dispatch(AT.ADD_TIME_PERIOD, formData)
        .then(res => {
          if (res && res.data) {
            const timePeriodExists = this.timePeriodsArray.some(timePeriod => {
             return timePeriod.id === res.data.id;
            });
            if (!timePeriodExists) {
              res.data.isDeletingTimePeriodLoading = false;
              this.timePeriodsArray.push(res.data);
            }
          }
          this.mapSrNoToTimePeriod();
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
         this.checkTimePeriod();
         this.timePeriodObject.id = '';
         this.timePeriodObject.description = '';
         this.timePeriodObject.startDate = '';
         this.timePeriodObject.endDate = '';
         this.showTimePeriodModal = false;
         this.isTableLoading = false;
        });
    },
    getTimePeriods() {
      this.isTimePeriodFormLoading = true;
      this.$store
        .dispatch(AT.GET_TIME_PERIODS)
        .then(res => {
          if (res) {
           this.timePeriodsArray = res.data.map((timePeriod, index) => {
                timePeriod.isDeletingTimePeriodLoading = false;
                timePeriod.srNo = index + 1;
                return timePeriod;
            });
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
            this.checkTimePeriod();
            this.isTimePeriodFormLoading = false;
        });
    },
    updateActionHandler(item){
         this.showTimePeriodModal = true;
         this.timePeriodObject.id = item.id;
         this.timePeriodObject.description = item.name;
         this.timePeriodObject.startDate = item.start_date;
         this.timePeriodObject.endDate = item.end_date;
         this.timePeriodObject.action = 'edit'
    },
    makeTimePeriodFromResponse(res){
        return{
            id:res.id,
            start_date:res.start_date,
            end_date:res.end_date,
            name:res.name
        };
    },
    updateTimePeriod(item){
       const formData = {
         name: item.description,
         id: item.id,
         end_date: item.endDate,
         start_date: item.startDate
       };
       this.$store
         .dispatch(AT.UPDATE_TIME_PERIOD, formData)
         .then(res => {
             this.timePeriodsArray = this.Array.map((timePeriod) => {
                 if (timePeriod.id === res.data.id) {
                     return this.makeTimePeriodFromResponse(res.data);
                 }
                 return timePeriod;
             });
            return;
         })
         .catch(err => {

           this.handleError(err);
         })
         .finally(() => {
         this.timePeriodObject.id = '';
         this.timePeriodObject.description = '';
         this.timePeriodObject.startDate = '';
         this.timePeriodObject.endDate = '';
         this.timePeriodObject.action = 'add';
         this.isTimePeriodFormLoading = false;
         this.showTimePeriodModal = false
         });
     },
    deleteTimePeriod(timePeriod) {
        this.isDeletingTimePeriod = true;
        // timePeriod.isDeletingTimePeriodLoading = true;
        this.$forceUpdate();
     const globalTimePeriodId = this.$store.getters.globalTimePeriod;
      if (globalTimePeriodId === timePeriod.id) {
        this.$store.dispatch(SNACKBAR, {
          color: "error",
          text: `Please Change Time Period First`
      });
      return;
      }
      this.$store
        .dispatch(AT.DELETE_TIME_PERIOD, timePeriod.id)
        .then(() => {
          this.timePeriodsArray.splice(
            this.timePeriodsArray.findIndex(timePeriodInner => timePeriodInner.id === timePeriod.id),
            1
          );
        this.mapSrNoToTimePeriod();
        })
        .catch(err => {
          this.handleError(err);
          return;
        })
        .finally(() => {
            this.checkTimePeriod();
            this.showDeleteConfirmationDialog = false;
            this.isDeletingTimePeriod = false;
          	timePeriod.isDeletingTimePeriodLoading = false;
        });
    },
    handleError(err) {
      var errorMessage = this.getErrorMessage(err);
      this.throwErrorMessage(errorMessage);
      return;
    },
    throwErrorMessage(errorMessage) {
      this.$store.dispatch(SNACKBAR, {
        color: "error",
        text: `${errorMessage}`
      });
      return;
    },
    getErrorMessage(err) {
      var errorMessage = "";
      if (err.data && err.data.message) {
        errorMessage = err.data.message;
      }
      if (err.data && err.data.errors) {
        errorMessage = [].concat.apply([], Object.values(err.data.errors));
      }
      return errorMessage;
    },
    closeDialog(){
        this.showTimePeriodModal = false;
    },
    checkTimePeriod() {
      if(this.timePeriodsArray.length <= 1){
          this.isLastTimePeriod = true;
      }
      else{
          this.isLastTimePeriod = false;
      }
    },
  },
  computed: {
    tableHeaders() {
      return [
        { text: "Sr No.", value: "srNo", align: "center" },
        { text: "Description", value: "name", align: "center" },
        { text: "Start Date", value: "start_date", align: "center" },
        { text: "End Date", value: "end_date", align: "center" },
        { text: "Action", value: "deleteAction", align: "center" }
      ];
    },
  }
}
</script>
